export const fullAddress = (user: Users.Search | UsersV2.Tile) => {
  const userAdress = [user.city_display, user.country_display].filter((n) => n).join(", ");
  const postcode = user.postcode_display || "";

  return `${postcode} ${userAdress}`;
};
